import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TenantPageApi } from '../api/tenantpage.api';
import { switchMap, map } from 'rxjs/operators';
import { TenantPage,TenantPageData } from '../../../interfaces/masters/tenantpage';

@Injectable()
export class TenantPageService extends TenantPageData {

  constructor(private api: TenantPageApi) {
    super();
  }


  list(): Observable<TenantPage[]> {
    return this.api.list();
  }




  getById(url: string): Observable<TenantPage>{
      return this.api.getById(url);
  }

  create(url: string, data: TenantPage[]): Observable<TenantPage> {
    return this.api.add(url,data);
  }

  update(url: string, data: TenantPage): Observable<TenantPage> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
